import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import NewsLetter from './page/newsletter/index.js';
import reportWebVitals from './reportWebVitals';
import MainPage from './page/mainPage/index.js';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SpecialtyCoffeePage from './page/informationPages/specialtyCoffee/index';
import CustomizePage from './page/informationPages/customizePage/index';
import PerfectCoffeePage from './page/informationPages/perfectCoffee/index';
import NotFound from './page/errorPages/index.js';
import LocalFarms from './page/informationPages/localFarms/index';
import Testing from './page/testing/index.js';
import Login from './page/login/index.js';
import OurProvidersPage from './page/informationPages/ourProviders';
import PolicyPage from './page/informationPages/policys/index';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<MainPage />}/>
      <Route path="/newsLetter" element={<NewsLetter />}/>
      <Route path="/specialtyCoffee" element={<SpecialtyCoffeePage />} />
      <Route path="/customizeYourOrder" element={<CustomizePage />} />
      <Route path="/perfectCoffee" element={<PerfectCoffeePage />} />
      <Route path="/localfarms" element={<LocalFarms />} />
      <Route path="/login" element={<Login />} />
      <Route path="/membership" element={<NotFound message="Page Coming Soon"/>} />
      <Route path="/ourCoffee" element={<NotFound message="Page Coming Soon"/>} />
      <Route path="/ForTesting" element={<Testing/>} />
      <Route path="/ourProviders" element={<OurProvidersPage/>} />
      <Route path="/policy" element={<PolicyPage/>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
